// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react'
import { authHeaderAPI } from 'redux/_helpers/auth-header'
import { baseQueryWithErrorHandler } from 'redux/_helpers/custom-base-query'

export const GlobalAPI = createApi({
  reducerPath: 'GlobalAPI',
  baseQuery: baseQueryWithErrorHandler,
  tagTypes: ['DynamicData'],
  endpoints: builder => ({
    getDynamicData: builder.query<any, any>({
      query: data => ({
        method: 'GET',
        url: `/${data.endPoint}`,
        params: data.params,
        headers: authHeaderAPI(),
      }),
      providesTags: ['DynamicData'],
    }),
  }),
})

// Export hooks for usage in functional components, which are
export const { useGetDynamicDataQuery } = GlobalAPI
